import { Legacy, AdmissionSeed } from '@/infrastructure/network/Legacy/schema'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

export class CheckIn implements APIRequest<Legacy.Admission.postAdmissionResponse> {
  response: Legacy.Admission.postAdmissionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Legacy.Admission.postAdmissionRequest
  constructor(params: AdmissionSeed) {
    this.params = params
    this.path = '/admissions'
  }
}

export class CheckOut implements APIRequest<Legacy.Admission.putAdmissionResponse> {
  response: Legacy.Admission.putAdmissionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PATCH
  params: Legacy.Admission.putAdmissionRequest
  constructor(params: AdmissionSeed) {
    this.params = params
    this.path = `/admissions/check-out`
  }
}
